module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/230-singapore-721cbe3f13f05cc0b4d5bd1c185b326b.svg";